/*
 * This file is part of the Norges Musikkhøyskole Nettsted 2020 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';

import Modal from 'components/Modal/Modal';
import Freeform from 'components/Freeform/Freeform';

import styles from './FormOverlay.module.scss';

/**
 * This is the FormOverlay component.
 *
 * @author Anders Stalheim Øfsdahl <anders@apt.no>
 *
 * @return {JSX}
 */
function FormOverlay({ visible, encodedForm, onClose, labels, heading, body }) {
  const handleSuccessClose = () => {
    onClose();
  };

  return (
    <Modal visible={visible} onClose={onClose} classNameClose={styles.close}>
      <div className={styles.wrapper} data-scroll-lock-scrollable>
        <div className="form__main">
          <div>
            {heading && <h2 className="entrylist__heading">{heading}</h2>}

            {body && <p>{body}</p>}
            <Freeform
              onSuccessClose={handleSuccessClose}
              encodedForm={encodedForm}
              labels={labels}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
FormOverlay.propTypes = {
  visible: PropTypes.bool,
  encodedForm: PropTypes.string,
  heading: PropTypes.string,
  body: PropTypes.string,
  labels: PropTypes.shape({
    success: PropTypes.string,
    error: PropTypes.string,
    requiredFields: PropTypes.string,
  }),
  onClose: PropTypes.func,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
FormOverlay.defaultProps = {
  visible: false,
  encodedForm: null,
  heading: null,
  body: null,
  labels: {
    success: 'Yay!',
    error: 'Nay!',
    requiredFields: 'Req!',
  },
  onClose: () => {},
};

export default FormOverlay;
